import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import { getPanelCount } from '_helpers';
import { PatientCareCenterNoteObjectiveObsPosture } from './Posture';
import { PatientCareCenterNoteObjectiveObsGait } from './Gait';
import { PatientCareCenterNoteObjectiveObsGeneral } from './General';
import { PatientCareCenterNoteObjectiveObsCircum } from './Circum';
import { PatientCareCenterNoteObjectiveObsPalpation } from './Palpation';
import { PatientCareCenterNoteObjectiveObsAccJointMob } from './AccJointMob';
import { PatientCareCenterNoteObjectiveObsFuncTest } from './FuncTest';
import { PatientCareCenterNoteObjectiveObsPosturePeds } from './PosturePeds';
import { PatientCareCenterNoteObjectiveObsRespiratoryPeds } from './Respiratory';
import { PatientCareCenterNoteObjectiveObsAttentionPeds } from './AttentionPeds';
import { PatientCareCenterNoteObjectiveObsBehaviorPeds } from './BehaviorPeds';
import { PatientCareCenterNoteObjectiveObsADLImpairmentsPeds } from './ADLImpairmentsPeds';
import { PatientCareCenterNoteObjectiveObsIADLImpairmentsPeds } from './IADLImpairmentsPeds';
import { PatientCareCenterNoteObjectiveObsOccupationImpairmentsPeds } from './OccupationImpairmentsPeds';
import { PatientCareCenterNoteObjectiveObsGrossMotorDevelopmentPeds } from './GrossMotorDevelopmentPeds';
import { PatientCareCenterNoteObjectiveObsGaitPeds } from './GaitPeds';
import { PatientCareCenterNoteObjectiveObsFineMotorDevelopmentPeds } from './FineMotorDevelopmentPeds';



class PatientCareCenterNoteObjectiveObs extends React.Component {

    render() {

        if ((this.props.panelCount > 0) || (this.props.isPeds && this.props.isPedsEnabled)) {
            return (

                <PatientCareCenterNoteSection id='obj_obs' name='Observations' level={1}>
                    {
                        (!this.props.isPeds || !this.props.isPedsEnabled) &&
                        <>
                            <PatientCareCenterNoteObjectiveObsPosture />
                            <PatientCareCenterNoteObjectiveObsGait />
                            <PatientCareCenterNoteObjectiveObsGeneral />
                            <PatientCareCenterNoteObjectiveObsCircum />
                            <PatientCareCenterNoteObjectiveObsPalpation />
                            <PatientCareCenterNoteObjectiveObsAccJointMob />
                            <PatientCareCenterNoteObjectiveObsFuncTest />
                        </>
                    }
                    {this.props.isPeds && this.props.isPedsEnabled &&
                        <>
                            <PatientCareCenterNoteObjectiveObsPosturePeds />
                            <PatientCareCenterNoteObjectiveObsRespiratoryPeds />
                            <PatientCareCenterNoteObjectiveObsAttentionPeds />
                            <PatientCareCenterNoteObjectiveObsBehaviorPeds />
                            <PatientCareCenterNoteObjectiveObsADLImpairmentsPeds />
                            <PatientCareCenterNoteObjectiveObsIADLImpairmentsPeds />
                            <PatientCareCenterNoteObjectiveObsOccupationImpairmentsPeds />
                            <PatientCareCenterNoteObjectiveObsGrossMotorDevelopmentPeds />
                            <PatientCareCenterNoteObjectiveObsGaitPeds />
                            <PatientCareCenterNoteObjectiveObsFineMotorDevelopmentPeds />
                        </>
                    }
                </PatientCareCenterNoteSection>
            );
        } else {
            return (
                <span />
            )
        }
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isPeds = state.entities.admissions[epno].isPeds;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_PEDS_ENABLED'].PRVALUE === 'true' : false;

    return {
        noteId: noteId,
        panelCount: getPanelCount(noteId, 'Observation'),
        isPeds: isPeds,
        isPedsEnabled: isPedsEnabled
    };
}

const connectedPatientCareCenterNoteObjectiveObs = connect(mapStateToProps)(PatientCareCenterNoteObjectiveObs);
export { connectedPatientCareCenterNoteObjectiveObs as PatientCareCenterNoteObjectiveObs };

